import { render, staticRenderFns } from "./NotificationPanel.vue?vue&type=template&id=57d5c022&scoped=true"
import script from "./NotificationPanel.vue?vue&type=script&lang=ts"
export * from "./NotificationPanel.vue?vue&type=script&lang=ts"
import style0 from "./NotificationPanel.vue?vue&type=style&index=0&id=57d5c022&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d5c022",
  null
  
)

export default component.exports